import Invitations                from 'scripts/defa/invitations/collection-invitations';
import InvitationController       from 'scripts/defa/invitations/controller-invitation-controller';
import Invitation                 from 'scripts/defa/invitations/model-invitation';
import InvitationRouter           from 'scripts/defa/invitations/router-invitation-router';
import InvitationSubscriptions    from 'scripts/defa/invitations/subscriptions/collection-invitation-subscriptions';
import InvitationSubscription     from 'scripts/defa/invitations/subscriptions/model-invitation-subscription';
import InvitationSubscriptionCollectionView
								  from 'scripts/defa/invitations/subscriptions/view-invitation-subscription-collection-view';
import InvitationSubscriptionView from 'scripts/defa/invitations/subscriptions/view-invitation-subscription-view';
import InvitationCollectionView   from 'scripts/defa/invitations/view-invitation-collection-view';
import InvitationContainer        from 'scripts/defa/invitations/view-invitation-container';
import InvitationFlow             from 'scripts/defa/invitations/view-invitation-flow';
import InvitationView             from 'scripts/defa/invitations/view-invitation-view';
import Module                     from 'scripts/module';

const InvitationModule = new Module('RecipientsModule',{
	collections: {
		Invitations,
		InvitationSubscriptions
	},
	controllers: {
		InvitationController
	},
	models     : {
		Invitation,
		InvitationSubscription
	},
	routers    : {
		InvitationRouter
	},
	views      : {
		InvitationSubscriptionCollectionView,
		InvitationSubscriptionView,
		InvitationCollectionView,
		InvitationContainer,
		InvitationFlow,
		InvitationView
	}
});
export default InvitationModule;
